import { render, staticRenderFns } from "./template-edit-option.vue?vue&type=template&id=e310f39a&scoped=true"
import script from "./template-edit-option.vue?vue&type=script&lang=ts"
export * from "./template-edit-option.vue?vue&type=script&lang=ts"
import style0 from "./template-edit-option.vue?vue&type=style&index=0&id=e310f39a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e310f39a",
  null
  
)

export default component.exports